import { SelectChangeEvent } from '@mui/material/Select'
import React, { useState } from 'react'
import LanguageCurrencyDropdown, { CountryOption, LanguageCurrencyDropdownProps } from './LanguageCurrencyDropdown'
import { setCookie } from '@/src/utils/browser'

const getCountryOptions = (t: (key: string) => string): CountryOption[] => [
    { code: 'EG', label: t('countries.egypt'), domain: 'eg.flyin.com', qaDomain: 'meeg.flyin.com' },
    { code: 'UAE', label: t('countries.uae'), domain: 'ae.flyin.com', qaDomain: 'meae.flyin.com' },
    { code: 'GLOBAL', label: t('countries.global'), domain: 'www.flyin.com', qaDomain: 'me.flyin.com' }
]

const detectCurrentCountry = (hostname: string, countryOptions: CountryOption[], isQA: boolean): CountryOption => {
    // Find the country that matches the current hostname
    const matchedCountry = countryOptions.find(country => {
        const targetDomain = isQA ? country.qaDomain : country.domain
        return hostname.includes(targetDomain)
    })
    // Return matched country or global options
    return matchedCountry || countryOptions[2]
}
interface LanguageCurrencyDropdownLogicProps {
    selectedLanguage: LanguageCurrencyDropdownProps['selectedLanguage']
    selectedCurrency: LanguageCurrencyDropdownProps['selectedCurrency']
    languageOptions: LanguageCurrencyDropdownProps['languageOptions']
    currencyOptions: LanguageCurrencyDropdownProps['currencyOptions']
    onLanguageSelect: LanguageCurrencyDropdownProps['onLanguageSelect']
    onCurrencySelect: LanguageCurrencyDropdownProps['onCurrencySelect']
    t: LanguageCurrencyDropdownProps['t']
    tCurrency: LanguageCurrencyDropdownProps['tCurrency']
    isOffersPage?: boolean
}

const LanguageCurrencyDropdownLogic: React.FC<LanguageCurrencyDropdownLogicProps> = props => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [countrySelectOpen, setCountrySelectOpen] = useState(false)
    const open = Boolean(anchorEl)
    const isQA = typeof window !== 'undefined' && window.location.hostname.includes('me')
    const countryOptions = getCountryOptions(props.t)

    const getCurrentCountry = (): CountryOption => {
        if (typeof window === 'undefined') return countryOptions[0]

        const currentHostname = window.location.hostname
        return detectCurrentCountry(currentHostname, countryOptions, isQA)
    }

    const [selectedCountry, setSelectedCountry] = useState<CountryOption>(() => {
        const country = getCurrentCountry()
        return country || countryOptions[1]
    })

    const handleCountryChange = (event: SelectChangeEvent) => {
        const countryCode = event.target.value
        const newCountry = countryOptions.find(c => c.code === countryCode) || countryOptions[0]

        if (newCountry.code === selectedCountry.code) return

        setSelectedCountry(newCountry)
        setCookie('cc', newCountry.code)
        const targetDomain = isQA ? newCountry.qaDomain : newCountry.domain
        const currentUrl = new URL(window.location.href)
        currentUrl.hostname = targetDomain
        window.location.href = currentUrl.toString()
    }

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleCountrySelectOpen = () => setCountrySelectOpen(true)
    const handleCountrySelectClose = () => setCountrySelectOpen(false)

    return (
        <LanguageCurrencyDropdown
            {...props}
            selectedCountry={selectedCountry}
            countryOptions={countryOptions}
            countrySelectOpen={countrySelectOpen}
            onCountrySelectOpen={handleCountrySelectOpen}
            onCountrySelectClose={handleCountrySelectClose}
            onCountryChange={handleCountryChange}
            onCountrySelect={() => {}}
            open={open}
            anchorEl={anchorEl}
            onOpen={handleOpen}
            onClose={handleClose}
            isOffersPage={props.isOffersPage}
        />
    )
}

export default LanguageCurrencyDropdownLogic
